import { ArrowUp } from "lucide-react";
import { LogoMark } from "./Logo";

export const Footer = ({ t, go }) => (
  <footer data-testid="site-footer" className="overflow-hidden bg-[var(--ink)] pt-20 text-[var(--ivory)]">
    <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 md:flex-row md:items-center md:justify-between lg:px-10">
      <div className="flex items-center gap-4">
        <LogoMark className="h-12 w-12" />
        <p className="text-sm text-[#f4f1ea]/70">S&amp;LC Personnel Management SA de CV<br />© {new Date().getFullYear()} {t.footer.rights}</p>
      </div>
      <button onClick={() => go("top")} data-testid="footer-back-to-top" className="btn-ghost self-start md:self-auto">
        <ArrowUp className="h-4 w-4" />{t.footer.top}
      </button>
    </div>
    <p aria-hidden="true" className="mt-12 select-none whitespace-nowrap text-center font-display text-[24vw] font-light italic leading-[0.8] tracking-[-0.05em] text-[#f4f1ea]/[0.06]">S&amp;LC</p>
  </footer>
);
